import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { SelectPartQuantityModalController } from "./controller";

export const vsServiceName = "selectPartQuantityModalService";

export interface SelectPartQuantityModalOptions {
  partQuantitySelected: (partLocation: any) => void;
}

const defaultOptions: SelectPartQuantityModalOptions = {
  partQuantitySelected: () => {},
};

export class SelectPartQuantityModalService {
  static $inject = ["$uibModal"];

  constructor(private readonly $uibModal: angular.ui.bootstrap.IModalService) {}

  open(options?: SelectPartQuantityModalOptions) {
    options ??= defaultOptions;

    this.$uibModal.open({
      controller: SelectPartQuantityModalController,
      controllerAs: "selectPartQuantityModalController",
      template: require("!html-loader!./index.html").default,
      size: "lg",
      resolve: {
        options: [() => options],
        partProperties: [
          ServerUtilityName,
          (serverUtility: ServerUtility) =>
            serverUtility
              .fetchAll({
                url: "/api/parts/properties",
                query: {
                  OrderBy: "Name",
                },
              })
              .then((results) => [
                {
                  Id: undefined,
                  Name: "All",
                },
                ...results,
              ]),
        ],
      },
    });
  }
}
